
// import React from "react";

// // Format Firestore Timestamp (or JS Date) to a readable time
// function formatTime(ts) {
//     try {
//         // Accepts Firestore Timestamp or JS Date
//         const date =
//             ts && ts.toDate
//                 ? ts.toDate()
//                 : ts instanceof Date
//                     ? ts
//                     : new Date(ts);
//         return date.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit", second: "2-digit" });
//     } catch {
//         return "--:--";
//     }
// }

// export default function CrashHistoryTable({ rounds = [], loading = false }) {
//     return (
//         <div className="w-full max-w-md mx-auto">
//             <div className="flex justify-between font-bold text-[#a3f664] text-base mb-2 px-2">
//                 <span>Round</span>
//                 <span className="hidden sm:inline">Time</span>
//                 <span>Crashed At</span>
//             </div>
//             <div className="flex flex-col gap-1">
//                 {loading && (
//                     <div className="text-center text-gray-400 py-4">Loading...</div>
//                 )}
//                 {!loading && (!rounds || rounds.length === 0) && (
//                     <div className="text-gray-400 text-center py-4">No history yet.</div>
//                 )}
//                 {rounds &&
//                     rounds.map((r, idx) => (
//                         <div
//                             key={r.id || idx}
//                             className="flex justify-between items-center px-3 py-2 rounded-xl bg-[#232d42] hover:bg-[#293158] transition mb-1 shadow-sm"
//                         >
//                             <span className="font-mono text-[#81d1f7] text-xs sm:text-base">
//                                 #{r.roundNumber || r.id?.slice(-5) || idx + 1}
//                             </span>
//                             <span className="hidden sm:inline text-gray-300 text-xs font-mono">{formatTime(r.startTime)}</span>
//                             <span
//                                 className={`font-bold text-lg sm:text-xl ${r.crashAt < 2
//                                         ? "text-red-400"
//                                         : r.crashAt < 10
//                                             ? "text-[#e1ff80]"
//                                             : "text-[#64ff58]"
//                                     }`}
//                             >
//                                 {typeof r.crashAt === "number"
//                                     ? r.crashAt.toFixed(2) + "x"
//                                     : "--"}
//                             </span>
//                         </div>
//                     ))}
//             </div>
//         </div>
//     );
// }

import React from "react";

// Format Firestore Timestamp (or JS Date) to readable time
function formatTime(ts) {
    try {
        const date =
            ts && ts.toDate
                ? ts.toDate()
                : ts instanceof Date
                    ? ts
                    : new Date(ts);
        return date.toLocaleTimeString([], {
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
        });
    } catch {
        return "--:--";
    }
}

// Shorten long hex for UI
function shortHex(str, len = 10) {
    if (!str) return "";
    if (str.length <= len * 2) return str;
    return str.slice(0, len) + "..." + str.slice(-len);
}

export default function CrashHistoryTable({ rounds = [], loading = false }) {
    return (
        <div className="w-full max-w-md mx-auto">
            <div className="mb-2 flex justify-between px-2 text-base font-bold text-slate-300">
                <span>Round</span>
                <span className="hidden sm:inline">Time</span>
                <span>Crashed At</span>
            </div>
            <div className="flex flex-col gap-2">
                {loading && (
                    <div className="text-center text-gray-400 py-4">Loading...</div>
                )}
                {!loading && (!rounds || rounds.length === 0) && (
                    <div className="text-gray-400 text-center py-4">No history yet.</div>
                )}
                {rounds &&
                    rounds.map((r, idx) => {
                        const provably = r.provablyFair || {};
                        return (
                            <div
                                key={r.id || idx}
                                className="mb-1 flex flex-col gap-1 rounded-xl bg-[#171d26] px-3 py-2 transition hover:bg-[#1d2430]"
                            >
                                {/* TOP LINE: round, time, crashAt */}
                                <div className="flex justify-between items-center">
                                    <span className="font-mono text-xs text-slate-200 sm:text-base">
                                        #{r.roundNumber || r.id?.slice(-5) || idx + 1}
                                    </span>
                                    <span className="hidden sm:inline text-gray-300 text-xs font-mono">
                                        {formatTime(r.startTime)}
                                    </span>
                                    <span
                                        className={`font-bold text-lg sm:text-xl ${typeof r.crashAt === "number"
                                                ? r.crashAt < 2
                                                    ? "text-red-400"
                                                    : r.crashAt < 10
                                                        ? "text-[#e1ff80]"
                                                        : "text-[#64ff58]"
                                                : ""
                                            }`}
                                    >
                                        {typeof r.crashAt === "number"
                                            ? r.crashAt.toFixed(2) + "x"
                                            : "--"}
                                    </span>
                                </div>
                                {/* SECOND LINE: provably fair */}
                                {provably.hash && (
                                    <div className="flex flex-wrap gap-x-4 gap-y-1 items-center text-xs sm:text-sm text-gray-300 font-mono pt-1">
                                        <span>
                                            <span className="text-gray-400">Hash:</span>{" "}
                                            <span className="break-all">{shortHex(provably.hash)}</span>
                                        </span>
                                        <span>
                                            <span className="text-gray-400">Nonce:</span>{" "}
                                            <span>{provably.nonce}</span>
                                        </span>
                                        <span>
                                            <span className="text-gray-400">Seed:</span>{" "}
                                            <span className="break-all">{shortHex(provably.serverSeedHash || provably.seed || provably.serverSeed)}</span>
                                        </span>
                                    </div>
                                )}
                            </div>
                        );
                    })}
            </div>
        </div>
    );
}
